module.exports = __webpack_public_path__ + "media/B6.d5417357.mp3";